<template>
  <BulkActionMenu :actions="actions">
    <template v-slot:update="{ hide }">
      <Update
        :module-name="moduleName"
        :selected-ids="selectedItemIds"
        @trigger="hide"
        @done="handleActionDone"
        @bulk-update-error="handleFailedResponse"
      />
    </template>
    <template v-slot:add_solution="{ hide }">
      <AddSolution
        :module-name="moduleName"
        :selected-ids="selectedItemIds"
        @trigger="hide"
        @done="handleActionDone"
        @bulk-update-error="handleFailedResponse"
      />
    </template>
    <template v-slot:merge="{ hide }">
      <Merge
        :module-name="moduleName"
        :selected-item-ids="selectedItemIds"
        :defautl-primary="defautlPrimary"
        @trigger="hide"
        @done="handleActionDone"
      />
    </template>
    <template v-slot:mark_as_spam="{ hide }">
      <MarkAsSpam
        :module-name="moduleName"
        :handle-spam-requests="handleMarkAsSpam"
        @trigger="hide"
      />
    </template>
    <template v-slot:restore="{ hide }">
      <Restore
        :module-name="moduleName"
        :handle-restore-items="restoreItems"
        @trigger="hide"
      />
    </template>
    <template v-slot:delete="{ hide }">
      <Delete
        :module-name="moduleName"
        :handle-delete-items="deleteItems"
        @trigger="hide"
      />
    </template>
    <template v-slot:unmark_as_spam="{ hide }">
      <UnmarkAsSpam
        :module-name="moduleName"
        :handle-un-spam-requests="markAsUnspam"
        @trigger="hide"
      />
    </template>
    <template v-slot:claim="{ hide }">
      <Claim
        :module-name="moduleName"
        :selected-item-ids="selectedItemIds"
        :handle-claim-requests="handleClaimRequests"
        @trigger="hide"
      />
    </template>
    <template v-slot:assign="{ hide }">
      <Assign
        :module-name="moduleName"
        :selected-item-ids="selectedItemIds"
        :handle-assign-requests="handleAssignRequests"
        @trigger="hide"
      />
    </template>
    <template v-slot:archive="{ hide }">
      <Archive
        :module-name="moduleName"
        :handle-archive-requests="bulkDelete"
        @trigger="hide"
      />
    </template>
    <template v-slot:close="{ hide }">
      <Close
        :module-name="moduleName"
        :handle-close-requests="handleCloseRequests"
        @trigger="hide"
      />
    </template>
    <template v-slot:resolve="{ hide }">
      <Resolve
        :module-name="moduleName"
        :handle-resolve-requests="handleResolveRequests"
        @trigger="hide"
      />
    </template>
  </BulkActionMenu>
</template>

<script>
import BulkActionMenu from '@components/bulk-action-menu'
import { authComputed } from '@state/modules/auth'
import { StatusComputed } from '@state/modules/status'
import {
  bulkUpdateApi,
  bulkDeleteApi,
  bulkUnMarkAsSpamApi,
  bulkUnarchiveApi,
  bulkPermanentDeleteApi,
} from '../ticket-api'
import Update from './action-menu-items/update'
import AddSolution from './action-menu-items/add-solution'
import MarkAsSpam from './action-menu-items/mark-as-spam'
import UnmarkAsSpam from './action-menu-items/unmark-as-spam'
import Archive from './action-menu-items/archive'
import Restore from './action-menu-items/restore'
import Delete from './action-menu-items/delete'
import Claim from './action-menu-items/claim'
import Assign from './action-menu-items/assign'
import Close from './action-menu-items/close'
import Resolve from './action-menu-items/resolve'
import Merge from './action-menu-items/merge/merge'

export default {
  name: 'BulkActions',
  components: {
    BulkActionMenu,
    Update,
    AddSolution,
    MarkAsSpam,
    Archive,
    Claim,
    Assign,
    Close,
    Resolve,
    Merge,
    UnmarkAsSpam,
    Restore,
    Delete,
  },
  props: {
    moduleName: { type: String, required: true },
    mode: { type: String, default: undefined },
    selectedItemIds: { type: Array, required: true },
    selectedItemFullDetails: { type: Array, required: true },
    items: { type: Array, required: true },
    toggleSelectAll: { type: Function, required: true },
    refreshList: { type: Function, required: true },
    defautlPrimary: { type: Object, default: undefined },
  },
  data() {
    let actions = [
      'update',
      'merge',
      'claim',
      'assign',
      'resolve',
      'close',
      'mark_as_spam',
      'archive',
    ]
    if (this.mode === 'spam') {
      actions = ['unmark_as_spam', 'archive']
    }
    if (this.mode === 'archive') {
      actions = ['restore', 'delete']
    }
    if (this.moduleName !== this.$constants.REQUEST) {
      actions = actions.filter((a) => ['mark_as_spam'].indexOf(a) === -1)
    }
    if (this.moduleName !== this.$constants.REQUEST) {
      actions = actions.filter((c) => c !== 'merge')
    }
    if (
      this.moduleName === this.$constants.CHANGE ||
      this.moduleName === this.$constants.RELEASE
    ) {
      actions = actions.filter((c) => c !== 'close' && c !== 'resolve')
    }
    if (this.moduleName === this.$constants.PROBLEM) {
      actions = actions.filter((c) => c !== 'resolve')
    }
    if (
      (this.moduleName === this.$constants.REQUEST ||
        this.moduleName === this.$constants.PROBLEM) &&
      ['spam', 'archive'].indexOf(this.mode) === -1
    ) {
      actions = actions.concat(['add_solution'])
    }
    this.actions = actions
    return {
      rendorCount: 1,
    }
  },
  computed: {
    ...authComputed,
    ...StatusComputed,
  },
  watch: {
    selectedItemIds: {
      handler(newValue) {
        this.rendorCount = this.rendorCount + 1
      },
    },
  },
  methods: {
    unselectAll() {
      this.toggleSelectAll()
    },
    handleActionDone() {
      this.refreshList()
    },
    handleClaimRequests() {
      return this.bulkUpdate({ technicianId: this.user.id })
    },
    handleAssignRequests(userId) {
      return this.bulkUpdate({ technicianId: userId })
    },
    handleCloseRequests() {
      if (this[`${this.moduleName}FindStatus`]) {
        const closedStatus = this[`${this.moduleName}FindStatus`]('closed')
        if (closedStatus) {
          return this.bulkUpdate({ statusId: closedStatus.id })
        }
        return Promise.resolve()
      }
      return Promise.resolve()
    },
    handleResolveRequests() {
      if (this[`${this.moduleName}FindStatus`]) {
        const resolvedStatus = this[`${this.moduleName}FindStatus`]('resolved')
        if (resolvedStatus) {
          return this.bulkUpdate({ statusId: resolvedStatus.id })
        }
        return Promise.resolve()
      }
      return Promise.resolve()
    },
    handleMarkAsSpam() {
      return this.bulkUpdate({ spam: true }).then(() => this.refreshList())
    },
    markAsUnspam() {
      return bulkUnMarkAsSpamApi(this.selectedItemIds).then(() =>
        this.refreshList()
      )
    },
    restoreItems() {
      return bulkUnarchiveApi(this.moduleName, this.selectedItemIds).then(() =>
        this.refreshList()
      )
    },
    deleteItems() {
      return bulkPermanentDeleteApi(this.moduleName, this.selectedItemIds).then(
        () => this.refreshList()
      )
    },
    bulkUpdate(data) {
      return bulkUpdateApi(this.moduleName, this.selectedItemIds, data).then(
        (response) => {
          if (response.failed.length) {
            this.handleFailedResponse(response.failed)
          }
          this.refreshList()
        }
      )
    },
    handleFailedResponse(failed) {
      const items = failed
        .map((f) => {
          const i = this.selectedItemFullDetails.find((x) => x.id === f.id)
          if (i) {
            return {
              ...f,
              subject: i.subject,
              name: i.name,
            }
          }
          return undefined
        })
        .filter(Boolean)
      this.$emit('bulk-update-error', items)
    },
    bulkDelete() {
      return bulkDeleteApi(this.moduleName, this.selectedItemIds).then(
        (response) => {
          if (response.failed.length) {
            this.handleFailedResponse(response.failed)
          }
          this.refreshList()
        }
      )
    },
  },
}
</script>
